module.exports = __webpack_public_path__ + "assets/img/cricket-player.100344b3.png";